import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { PlaceEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class PlaceService {

    /** It gets all Place. */
    async getPlaces(options: IListFilter): Promise<ResponseBase<ResponseListBase<PlaceEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/place/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific Place by Place id */
    async getPlace(id: string, language: string): Promise<ResponseBase<ResponseContentBase<PlaceEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/place/') + id + `?language=${language || "en"}`);
    }

    /** It creates Place by request */
    async createPlace(request: PlaceEntity): Promise<ResponseBase<ResponseContentBase<PlaceEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/place/'), request);
    }

    /** It updates spesific Place by id */
    async updatePlace(request: PlaceEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/place/') + request.id, request);
    }

    /** It deletes spesific Place by id */
    async deletePlace(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/place/') + id);
    }
}
